import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "./LegalPageLayout.tsx";
import { ImpressumBg } from "./content/ImpressumBg.tsx";
import { ImpressumEn } from "./content/ImpressumEn.tsx";

const contents = { bg: ImpressumBg, en: ImpressumEn } as const;

export const ImpressumPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language.split("-")[0] === "bg" ? "bg" : "en";
  const Content = contents[lang];
  return (
    <LegalPageLayout>
      <Content />
    </LegalPageLayout>
  );
};
